<!-- src/components/Login.vue -->
<template>
  <div class="login-container">
    <!-- 波浪背景 -->
    <div class="wave-bg"></div>

    <!-- 登录卡片 -->
    <el-card class="login-card" shadow="hover">
      <h2 class="login-title">账号登录</h2>
      <el-form :model="loginForm" ref="loginFormRef" :rules="rules">
        <el-form-item prop="username">
          <el-input v-model="loginForm.username" placeholder="账号" clearable>

          <template #prefix>
            <el-icon class="input-icon">
              <User />
            </el-icon>
          </template>
          </el-input>
        </el-form-item>

        <el-form-item prop="password">
          <el-input v-model="loginForm.password" type="password" placeholder="密码" show-password clearable>

          <template #prefix>
            <el-icon class="input-icon">
              <Lock />
            </el-icon>
          </template>
        </el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="handleLogin" :loading="loading" class="login-btn">
            立即登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import axios from 'axios'
import md5 from 'md5'
import Cookies from 'js-cookie'
import config from '@/config'
import { User, Lock } from '@element-plus/icons-vue'

export default {
  name: 'LawyerLogin',
  components: {
    User,
    Lock
  },
  setup() {
    const router = useRouter()
    const loginForm = ref({
      username: '',
      password: ''
    })
    const loading = ref(false)
    const loginFormRef = ref(null)
    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ]
    }
    const handleLogin = () => {
      loginFormRef.value.validate(async (valid) => {
        if (!valid) return

        loading.value = true
        try {
          // 调用登录接口
          const response = await axios.post(
            `${config.BASE_URL}/shop/api/login.php`,
            {
              account: loginForm.value.username,
              password: md5(loginForm.value.password) // MD5加密
            }
          )

          if (response.data.code === 200) {
            // 存储登录信息到Cookies
            Cookies.set('user_token', response.data.data.id, { expires: 7 })
            Cookies.set('user_info', JSON.stringify(response.data.data), { expires: 7 })

            ElMessage.success(response.data.message)
            router.push('/store')
          } else {
            // 处理不同错误类型
            const errorMessages = {
              400: '请输入完整的账号密码',
              401: '账号或密码错误',
              403: response.data.message,
              500: '服务器错误，请稍后再试'
            }
            ElMessage.error(errorMessages[response.data.code] || '登录失败')
          }
        } catch (error) {
          // 网络错误处理
          if (!error.response) {
            ElMessage.error('网络连接异常，请检查网络')
          } else {
            ElMessage.error('登录失败，请重试')
          }
        } finally {
          loading.value = false
        }
      })
    }

    return {
      loginForm,
      rules,
      loginFormRef,
      loading,
      handleLogin
    }
  }
}
</script>

<style scoped>
.login-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #4772ff, #5851ff);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.wave-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: url('~@/assets/bg.png') repeat-x;
  background-size: contain;
  z-index: 1;
}

.login-card {
  width: 420px;
  padding: 40px 35px;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  transform: translateY(-10%);
  z-index: 2;
  position: relative;
  background: rgba(255, 255, 255, 0.96);
}

.login-title {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 35px;
  font-size: 24px;
  font-weight: 600;
}

.input-icon {
  color: #999;
  font-size: 18px;
  margin-left: 4px;
}



:deep(.el-input__inner) {
  height: 48px;
  border-radius: 8px;
  transition: border-color 0.3s;

}

:deep(.el-input__inner):focus {
  border-color: #4772ff;
}

/* 新增样式 */
:deep(.el-input__prefix) {
  left: 12px;
  display: flex !important;
  align-items: center;
  height: 100%;
}

.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(135deg, #4772ff, #5851ff);
  border: none;
  transition: opacity 0.3s;
}

.login-btn:hover {
  opacity: 0.9;
}
</style>